/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import { StyleSheet } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography';
import { ticketColors } from '../../../shared/theme/ticketColors'
import { ticketSurfaces } from '../../../shared/ticket/ticketSurfaces.styles';

export const cashPanelStyles = StyleSheet.create({
  turnoPanelScroll: {
    flex: 1,
    minHeight: 0,
  },
  turnoPanelContent: {
    gap: spacing.md,
    paddingBottom: spacing.lg,
  },
  turnoWorkspaceCardBody: {
    gap: spacing.md,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.sm,
  },
  turnoWorkspaceCardTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
    marginBottom: spacing.xs,
  },
  turnoWorkspaceTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: spacing.sm,
    marginBottom: spacing.sm,
  },
  turnoWorkspaceTitleIconOpen: {
    width: 36,
    height: 36,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(74, 222, 128, 0.12)',
    borderWidth: 1,
    borderColor: 'rgba(74, 222, 128, 0.35)',
  },
  turnoWorkspaceTitleIconClosed: {
    width: 36,
    height: 36,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(250, 204, 21, 0.1)',
    borderWidth: 1,
    borderColor: 'rgba(250, 204, 21, 0.35)',
  },
  sectionLabel: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '800',
    letterSpacing: 0.35,
    textTransform: 'uppercase',
  },
  sectionLabelMobile: {
    fontSize: 11,
    fontWeight: '700',
    color: ticketColors.ink3,
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    marginTop: 4,
  },
  panelTitleMobile: {
    fontSize: 17,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  cashHeroBand: {
    ...ticketSurfaces.paperSheet,
    ...ticketSurfaces.paperSheetPadded,
    gap: spacing.xs,
  },
  cashHeroBandMobile: {
    borderRadius: 14,
    paddingVertical: 12,
    paddingHorizontal: 14,
    gap: 4,
  },
  cashHeroKickerMobile: {
    color: ticketColors.gold,
    fontSize: 11,
    fontWeight: '800',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  cashHeroSubtitleMobile: {
    color: ticketColors.ink2,
    fontWeight: '600',
    fontSize: 13,
    lineHeight: 18,
  },
  cashHeroLinkMobile: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.gold,
    marginTop: 2,
  },
  cashHeroKicker: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '800',
    letterSpacing: 0.45,
    textTransform: 'uppercase',
  },
  cashHeroSubtitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
    fontVariant: ['tabular-nums'],
  },
  turnoOpenPanelHighlight: {
    borderColor: ticketColors.brandBorder,
  },
  turnoMetaHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
    marginBottom: spacing.xs,
  },
  turnoContextTitle: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '800',
    letterSpacing: 0.35,
    textTransform: 'uppercase',
  },
  turnoEmptyHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
    fontStyle: 'italic',
  },
  turnoClosePanel: {
    ...ticketSurfaces.paperSheet,
    ...ticketSurfaces.paperSheetPadded,
    gap: spacing.xs,
  },
  turnoClosePanelMobile: {
    borderRadius: 14,
  },
  turnoCloseTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  turnoCloseHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
    marginBottom: spacing.xs,
  },
  turnoPrimaryAction: {
    marginTop: spacing.xs,
  },
  turnoOpenPanel: {
    ...ticketSurfaces.paperSheet,
    ...ticketSurfaces.paperSheetPadded,
    gap: spacing.sm,
  },
  turnoOpenPanelMobile: {
    borderRadius: 14,
  },
  turnoOpenTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontWeight: '800',
  },
  turnoOpenInfoBox: {
    backgroundColor: ticketColors.paper2,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
  },
  turnoOpenInfoText: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  turnoOpenInfoStrong: {
    color: ticketColors.ink,
    fontWeight: '700',
  },
  turnoOpenMoneyField: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    paddingHorizontal: spacing.md,
  },
  turnoOpenMoneyPrefix: {
    ...typography.titleLg,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  turnoOpenMoneyInput: {
    flex: 1,
    minWidth: 0,
    paddingVertical: spacing.sm,
    fontSize: 17,
    fontWeight: '700',
    fontVariant: ['tabular-nums'],
    color: ticketColors.ink,
  },
  closedGridDesktop: {
    flexDirection: 'row',
    gap: spacing.md,
    alignItems: 'flex-start',
  },
  closedGridMain: {
    flex: 1,
    minWidth: 0,
  },
  closedGridSide: {
    flex: 1,
    minWidth: 0,
    gap: spacing.sm,
  },
  /** Header de sección dentro de una list card flush (proto .dayhdr). */
  closedListHeader: {
    fontSize: 11.5,
    fontWeight: '800',
    letterSpacing: 0.7,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    paddingHorizontal: 16,
    paddingTop: 14,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },
  // Apertura como modal sobre el tab Turno cerrado (proto v-cerrada):
  // backdrop in-page (no portal RN — conserva testIDs en scope cash-workspace).
  openModalBackdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: ticketColors.dim,
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: 56,
    paddingHorizontal: spacing.lg,
    zIndex: 10,
  },
  openModalCard: {
    width: 520,
    maxWidth: '100%',
    backgroundColor: ticketColors.paper,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    overflow: 'hidden',
    shadowColor: '#1C1917',
    shadowOpacity: 0.3,
    shadowRadius: 40,
    shadowOffset: { width: 0, height: 16 },
    elevation: 12,
  },
  openModalHead: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 14,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },
  openModalClose: {
    padding: 4,
    marginTop: -2,
    marginRight: -4,
  },
  openModalKicker: {
    fontSize: 11,
    fontWeight: '800',
    letterSpacing: 0.9,
    textTransform: 'uppercase',
    color: ticketColors.brandPrimary,
  },
  openModalTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontWeight: '800',
  },
  openModalSub: {
    ...typography.caption,
    color: ticketColors.ink3,
    lineHeight: 18,
  },
  openModalBody: {
    paddingHorizontal: 20,
    paddingVertical: 16,
    gap: spacing.md,
  },
  openModalFoot: {
    paddingHorizontal: 20,
    paddingVertical: 14,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
  },
  closedCashOutflowsHint: {
    gap: spacing.xs,
    marginTop: spacing.sm,
    paddingTop: spacing.sm,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  hintLink: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '700',
  },
  teaserRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: spacing.sm,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    marginTop: spacing.sm,
  },
  teaserTextCol: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  teaserTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  teaserSubtitle: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  teaserRowDivider: {
    borderTopWidth: 0,
  },
  turnoHeroCard: {
    gap: 6,
  },
  turnoHeroLabel: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '800',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  turnoHeroAmount: {
    fontSize: 30,
    fontWeight: '800',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  turnoHeroBreakdown: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
    fontVariant: ['tabular-nums'],
  },
  turnoHeroSub: {
    ...typography.caption,
    color: ticketColors.ink3,
  },
  turnoKpiGrid: {
    flexDirection: 'row',
    gap: spacing.sm,
    flexWrap: 'wrap',
  },
  turnoKpiTile: {
    flex: 1,
    minWidth: 150,
    backgroundColor: ticketColors.tile,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingVertical: 10,
    paddingHorizontal: 12,
    gap: 2,
  },
  turnoKpiTileWarn: {
    backgroundColor: ticketColors.warnBg,
    borderColor: ticketColors.warnBorder,
  },
  turnoKpiTileLabel: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '700',
    letterSpacing: 0.4,
    textTransform: 'uppercase',
  },
  turnoKpiTileValue: {
    fontSize: 16,
    fontWeight: '800',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  turnoKpiTileValueWarn: {
    color: ticketColors.warn,
  },
  turnoKpiTileSub: {
    ...typography.caption,
    color: ticketColors.ink3,
  },
  detailHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
    marginBottom: spacing.sm,
  },
  detailTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontWeight: '800',
    flex: 1,
    minWidth: 0,
  },
  workspaceDetailCardBody: {
    gap: spacing.sm,
  },
  sessionMovementsBlock: {
    marginTop: spacing.md,
    paddingTop: spacing.md,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  turnoPanelSectionTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontWeight: '800',
    flexShrink: 1,
  },
  movementsErrorBanner: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    backgroundColor: ticketColors.paper2,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    marginBottom: spacing.sm,
  },
  movementsErrorRetry: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '700',
  },
  detailPanel: {
    gap: spacing.sm,
  },
  amountGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    marginVertical: spacing.sm,
  },
  amountCell: {
    flexGrow: 1,
    flexBasis: '30%',
    minWidth: 100,
    gap: 2,
  },
  amountLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  amountValue: {
    ...typography.body,
    fontWeight: '700',
    fontVariant: ['tabular-nums'],
    color: ticketColors.ink,
  },
  historialSectionHeader: {
    paddingTop: spacing.md,
    paddingBottom: spacing.sm,
    backgroundColor: 'transparent',
  },
  historialSectionHeaderFirst: {
    paddingTop: spacing.sm,
  },
  historialSectionHeaderNext: {
    paddingTop: spacing.md,
  },
  historialSectionHeaderWorkspace: {
    paddingTop: spacing.sm,
    paddingBottom: spacing.sm,
    paddingHorizontal: spacing.md,
    backgroundColor: ticketColors.paper2,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
  },
  historialSectionHeaderWorkspaceFirst: {
    paddingTop: spacing.sm,
  },
  historialSectionHeaderWorkspaceNext: {
    paddingTop: spacing.md,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  historialCardFooter: {
    paddingTop: 0,
    gap: spacing.sm,
  },
  historialCardEmpty: {
    paddingVertical: spacing.lg,
    gap: spacing.xs,
  },
  workspaceListScroll: {
    flex: 1,
    minHeight: 0,
  },
  sectionListContentWorkspace: {
    flexGrow: 1,
    paddingBottom: spacing.lg,
  },
  historyTableHeader: {
    marginBottom: 0,
  },
  historyTableHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingHorizontal: 0,
  },
  historyTableRowInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  historyTableCell: {
    fontSize: 14,
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  historyTableHeaderText: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.ink2,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  historyTableColTime: {
    flex: 1.1,
    minWidth: 72,
  },
  historyTableColMoney: {
    flex: 1.2,
    minWidth: 88,
    textAlign: 'right',
  },
  historyTableColDiff: {
    flex: 0.9,
    minWidth: 72,
    textAlign: 'right',
  },
  historyTableColChevron: {
    width: 22,
    marginLeft: 4,
  },
  denseRowBody: {
    paddingVertical: spacing.sm,
    gap: spacing.xs,
  },
  compactRowTitle: {
    fontSize: 15,
    fontWeight: '600',
    color: ticketColors.ink,
  },
  compactRowInner: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  compactDiff: {
    fontSize: 14,
    fontWeight: '700',
    marginRight: 4,
  },
  cashWorkspaceRoot: {
    flex: 1,
    alignSelf: 'stretch',
    width: '100%',
    backgroundColor: ticketColors.bg,
    minHeight: 0,
  },
});
